import { GenericModel } from "../../../generic.model";
import { DetailModel } from "./detail.model";
import { makeModel } from "../../../../service/utils/utils.service";
import { TotalModel } from "../total/total.model";


export class CostModel extends GenericModel {
    public currencyCode: string;
    public decimals: number;
    public type: string;
    public xId: string;
    public xRank: string;
    public xRole: string;
    public xState: string;
    public xTarget: string;
    public detailArray: DetailModel[];
    public total: TotalModel;

    protected fromJson(json?: any): boolean {
        this.currencyCode = json.currencyCode ?? null;
        this.decimals = json.decimals ?? null;
        this.type = json.type ?? null;
        this.xId = json.xId ?? null;
        this.xRank = json.xRank ?? null;
        this.xRole = json.xRole ?? null;
        this.xState = json.xState ?? null;
        this.xTarget = json.xTarget ?? null;
        this.detailArray = makeModel(json.detailArray, DetailModel);
        this.total = makeModel(json.total, TotalModel);
        return this.isValid();
    }

    protected isValid(): boolean {
        return this.xId !== null;
    }
}